





































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import Card from '@/components/Card.vue'
import { CONSTANTS, IUser, IUserChainRole } from '@zunta/configurations'
import Api from '@/api'
import { UserModule } from '@/store/modules/user.module'
import FileUploadLabel from '@/components/labels/FileUploadLabel.vue'
import SelectV2 from '@/components/inputsV2/SelectV2.vue'
import ButtonDownloadReport from '@/components/ButtonDownloadReport.vue'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import Tabs from '@/components/layout/Tabs.vue'

const { SALES_REP_ROLE_NAME } = CONSTANTS
@Component({
  components: {
    Tabs,
    DateTimeLabel,
    ButtonDownloadReport,
    Card,
    FileUploadLabel,
    SelectV2
  }
})
export default class BillingPage extends Vue {
  userModuleInstance: UserModule = getModule(UserModule, this.$store)

  get userId () {
    const user = parseInt(this.$route.params.user, 10)
    return !isNaN(user) ? user : null
  }

  get tabs () {
    return [
      {
        key: 'batches',
        value: {
          name: 'admin-billing-batches',
          params: this.$route.params
        },
        content: 'Batches'
      },
      {
        key: 'invoices',
        value: {
          name: 'admin-billing-invoices',
          params: this.$route.params
        },
        content: 'Invoices'
      }
    ]
  }

  get salesReps () {
    return this.$store.state.user.users.filter((user: IUser) => (
      (user.role as IUserChainRole).name === SALES_REP_ROLE_NAME
    ))
  }

  get userItemList () {
    return this.salesReps.map((user: IUser) => {
      return {
        value: user.id,
        content: `${user.firstName} ${user.lastName}`,
        key: user.id
      }
    })
  }

  async mounted () {
    await this.userModuleInstance.getAdminUsersList({
      limit: 1000
    })
  }

  selectUser (value: any) {
    const params: { [key: string]: string } = { ...this.$route.params }
    if (value) {
      params.user = value.toString()
    } else {
      delete params.user
    }
    // @ts-ignore
    this.$router.replace({
      name: this.$route.name,
      params: params,
      query: this.$route.query
    })
  }

  // importChainAdminUsers (file: File) {
  //   Api.user.importChainAdminUsers(file)
  // }
  //
  // importTrainingMilestoneTemplates (file: File) {
  //   Api.training.importTrainingMilestoneTemplates(file)
  // }
  //
  // importAccountDebit (file: File) {
  //   Api.billing.importAccountDebit(file)
  // }

  importBatchesReport (file: File) {
    Api.billing.importBatchesReport(file)
  }
}
